import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ssnmask'
})
export class SsnMaskPipe implements PipeTransform {

  transform(value: string | undefined, showMask : boolean) : string {
    if(value === null || value === undefined) { return ""; }

    if(value.length < 9) {
      return value;
    }
    if(showMask) { return "XXX-XX-" + value.slice(value.length - 4, value.length); }
    else { return value.slice(0, 3) + "-" + value.slice(3, 5) + "-" + value.slice(value.length - 4, value.length); }
  }
}
